export function getEmailDomain(email?: string): string | undefined {
    // Simple regex to match valid email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email && emailRegex.test(email)) {
        // Extract domain part after the '@' symbol
        return email.split('@')[1];
    }

    // Return null for invalid email addresses
    return;
}
